import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const AlertIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 612 569" {...props}>
      <path
        fill={fill}
        d="M448.1,347c6,13,0.4,28.4-12.5,34.4c-13,6-28.4,0.4-34.5-12.5c-1.6-3.5-2.4-7.2-2.4-10.9c-18.9,45.2-61.2,70.5-106.6,67.7v0.1c-0.1,0-11.6-1.1-11.9-11.7c-0.2-8.3,7-12.7,11.8-12.4c24.5,1.6,58.8-11.6,70.6-35.2c0,0-12.5-15.1-25.9-32.4c13.7-8.3,23.1-22,25.4-38.5c11.5,3.6,20.5,6.5,20.5,6.5c3.7-12.4-7.9-27.5-14.3-40c-2.2-4.2-1.3-11.7,5.7-15c7-3.2,11.5,0.3,13.8,4.4c22.9,25,30.3,61.5,16.2,90.9c2.5-3.2,5.6-6,9.6-7.9C426.6,328.3,442.1,334,448.1,347 M423.7,244.8c-7,4.4-14.5,0.3-16.7-4c-10.9-22-39.5-45.1-65.8-43.5c0,0-6.4,19.7-14,40.1c-5.7-2-11.5-3.6-17.8-3.6c-9,0-17.1,2.8-24.6,6.6c-5.2-15-9.4-28.3-9.4-28.3c-12.5,3-19.9,20.6-27.4,32.4c-2.6,4.1-9.5,7-15.8,2.6s-5.5-10.1-3.1-14.2c10.2-32.3,38.2-57,70.6-59.5c-4-0.5-8-1.9-11.6-4.3c-11.7-8.2-14.6-24.4-6.4-36.1c8.2-11.8,24.4-14.6,36.1-6.4s14.6,24.4,6.4,36.1c-2.2,3.2-5.1,5.7-8.3,7.5c48.6-6.2,91.7,17.8,112,58.4h0.1C427.9,228.7,432.7,239.2,423.7,244.8 M216.1,221.6c-13.6,20.4-19.3,56.8-4.8,78.8c0,0,21.6-6,44-11.2c0.3,16,7.7,29.9,19,39.6c-9.3,11.7-17.2,21.2-17.2,21.2c8.9,9.4,27.8,6.9,41.8,7.6c4.8,0.2,10.9,4.7,10.2,12.4c-0.7,7.7-6,9.8-10.7,9.8c-33.1,7.4-68.5-4.5-86.8-31.4c1.6,3.7,2.4,7.9,2,12.2c-1.2,14.3-13.8,24.8-28.1,23.6c-14.2-1.3-24.8-13.8-23.5-28.1c1.2-14.2,13.8-24.8,28.1-23.5c3.9,0.3,7.5,1.6,10.7,3.4c-29.7-38.9-30.4-88.3-5.4-126.1h-0.1c0.1-0.1,6.8-9.5,16.1-4.5C218.5,209.1,218.7,217.6,216.1,221.6M485.5,283.3c0-100-81.1-181-181-181c-100,0-181,81.1-181,181c0,100,81.1,181,181,181S485.5,383.2,485.5,283.3"
      />
    </Icon>
  );
};

AlertIcon.propTypes = {
  fill: PropTypes.string,
};

export default AlertIcon;
